import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBandlabComponent } from './simple-icons-bandlab.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBandlabComponent ],
    exports:      [ SimpleIconsBandlabComponent ],
    bootstrap:    []
})
export class SimpleIconsBandlabModule {}
